import { getStaticCdnUrl } from '@/utils';
import { checkTodayInRange } from '@/utils/checkTodayInRange';

// --- 월별 날짜 데이터 (매달 변경되는 부분만 관리) ---

type MonthlyDates = {
  range: readonly [string, string];
  variant: 'standard' | 'donation';
  issueText: string;
  useText: string;
  step2Text: string;
  step2SubText?: string;
  bannerLines: readonly string[];
  withdrawalDeadlineText: string;
  deadline: string;
  benefitDescription: string;
  complianceText: string;
};

export const MONTHLY_DATES: MonthlyDates[] = [
  {
    range: ['2026-03-01', '2026-03-31'],
    variant: 'standard',
    issueText: '2026. 3. 1(일) ~ 2026. 3. 31(화)',
    useText: '2026. 3. 1(일) ~ 2026. 4. 10(금)',
    step2Text:
      '26년 3월 1일부터 26년 4월 10일까지\n3만원 이상 이용 시 3만원 캐시백 지급',
    bannerLines: ['3만원 이상 이용하면 3만원 캐시백!'],
    withdrawalDeadlineText: '2026년 4월 30일(목)',
    deadline: '2026. 4. 30(목) 이내',
    benefitDescription: '최근 KB국민 체크카드 출금 계좌로 3만원 지급',
    complianceText:
      '준법감시인 심의필 260306-00602-HPM (2026.03.06~2027.03.05)',
  },
  {
    range: ['2026-04-01', '2026-04-30'],
    variant: 'standard',
    issueText: '2026. 4. 1(수) ~ 2026. 4. 30(목)',
    useText: '2026. 4. 1(수) ~ 2026. 5. 10(일)',
    step2Text:
      '26년 4월 1일부터 26년 5월 10일까지\n3만원 이상 이용 시 3만원 캐시백 지급',
    bannerLines: ['3만원 이상 이용하면 3만원 캐시백!'],
    withdrawalDeadlineText: '2026년 4월 30일(목)',
    deadline: '2026. 5. 29(금) 이내',
    benefitDescription: '최근 KB국민 체크카드 출금 계좌로 3만원 지급',
    complianceText:
      '준법감시인 심의필 260306-00602-HPM (2026.03.06~2027.03.05)',
  },
  {
    range: ['2026-05-01', '2026-05-31'],
    variant: 'donation',
    issueText: '2026. 5. 1(금) ~ 2026. 5. 31(일)',
    useText: '2026. 5. 1(금) ~ 2026. 6. 10(수)',
    step2Text: '26년 5월 1일부터 26년 6월 10일까지',
    step2SubText:
      '신규 발급 후 해당 카드로\n고향사랑 10만원 기부하면 총 18만원 혜택',
    bannerLines: [
      '10만원 이상 기부하면 5만원 캐시백!',
      '+ 고향사랑기부 총18만원 혜택!',
    ],
    withdrawalDeadlineText: '2026년 4월 30일(목)',
    deadline: '2026. 6. 30(화) 이내',
    benefitDescription: '최근 이용 KB국민체크카드 출금 계좌로 5만원 지급',
    complianceText: '준법감시인 심의필 260424-01402-HPM',
  },
  {
    range: ['2026-06-01', '2026-06-30'],
    variant: 'donation',
    issueText: '2026. 6. 1(월) ~ 2026. 6. 30(화)',
    useText: '2026. 6. 1(월) ~ 2026. 7. 10(금)',
    step2Text: '26년 6월 1일부터 26년 6월 30일까지',
    step2SubText:
      '신규 발급 후 해당 카드로\n고향사랑 10만원 기부하면 총 18만원 혜택',
    bannerLines: [
      '10만원 이상 기부하면 5만원 캐시백!',
      '+ 고향사랑기부 총18만원 혜택!',
    ],
    withdrawalDeadlineText: '2026년 4월 30일(목)',
    deadline: '2026. 7. 31(금) 이내',
    benefitDescription: '최근 이용 KB국민체크카드 출금 계좌로 5만원 지급',
    complianceText: '준법감시인 심의필 260424-01402-HPM',
  },
  {
    range: ['2026-08-01', '2026-08-31'],
    variant: 'donation',
    issueText: '2026. 8. 1(토) ~ 2026. 8. 31(월)',
    useText: '2026. 8. 1(토) ~ 2026. 9. 10(목)',
    step2Text: '26년 8월 1일부터 26년 8월 31일까지',
    step2SubText:
      '신규 발급 후 해당 카드로\n고향사랑 10만원 기부하면 총 16만원 혜택',
    bannerLines: [
      '10만원 이상 기부하면 3만원 캐시백!',
      '+ 고향사랑기부 총16만원 혜택!',
    ],
    withdrawalDeadlineText: '2026년 6월 30일(화)',
    deadline: '2026. 9. 30(수) 이내',
    benefitDescription: '최근 이용 KB국민체크카드 출금 계좌로 3만원 지급',
    complianceText: '준법감시인 심의필 260730-02551-HPM(2026.07.30~2027.07.29)',
  },
];

const currentDates =
  MONTHLY_DATES.find((d) => checkTodayInRange(d.range[0], d.range[1])) ??
  MONTHLY_DATES.at(-1)!;

const KB_CARD_LINKS = {
  nori2: {
    pc: 'https://card.kbcard.com/CRD/DVIEW/HCAMCXPRICAC0076?mainCC=a&cooperationcode=07964&solicitorcode=7030160001',
    mobile:
      'https://m.kbcard.com/CRD/DVIEW/MCAMCXHIACRC0002?mainCC=a&cooperationcode=07964&solicitorcode=7030160001',
  },
  travelers: {
    pc: 'https://card.kbcard.com/CRD/DVIEW/HCAMCXPRICAC0076?mainCC=a&cooperationcode=09564&solicitorcode=7030160001',
    mobile:
      'https://m.kbcard.com/CRD/DVIEW/MCAMCXHIACRC0002?mainCC=a&cooperationcode=09564&solicitorcode=7030160001',
  },
  youthClub: {
    pc: 'https://card.kbcard.com/CRD/DVIEW/HCAMCXPRICAC0076?mainCC=a&cooperationcode=04124&solicitorcode=7030160001',
    mobile:
      'https://m.kbcard.com/CRD/DVIEW/MCAMCXHIACRC0002?mainCC=a&cooperationcode=04124&solicitorcode=7030160001',
  },
} as const;

export const KB_EVENT = {
  variant: currentDates.variant,
  bannerLines: currentDates.bannerLines,
  /** 01 이벤트 기간 */
  period: {
    issueText: currentDates.issueText,
    useText: currentDates.useText,
  },

  /** 02 참여 대상 */
  eligibility: {
    conditions: [
      'KB국민 개인체크카드 최초 신규 발급 회원',
      '보유 체크카드 전체의 유효기간 만료 후 신규 발급 회원',
      `${currentDates.withdrawalDeadlineText} 이전 체크카드 탈회 후\n이벤트 기간 중 신규 발급 회원`,
    ],
  },

  /** 03 이벤트 내용 */
  content: {
    mainImage: getStaticCdnUrl('kb-card-event/main.png'),
    step2Text: currentDates.step2Text,
    step2SubText: currentDates.step2SubText,
  },

  /** 04 대상 카드 */
  cards: [
    {
      name: '노리2 체크카드(KB Pay)',
      subtitle: '국민 대표 체크카드 시즌2 개막',
      images: [
        {
          src: getStaticCdnUrl('kb-card-event/card-1.png'),
          alt: '노리2 체크카드',
        },
      ],
      tags: ['#국내전용', '#국내외겸용(Master,VISA)', '#연회비 없음'],
      benefits: [
        { label: '커피, 모바일, 문화', highlight: '10% 할인' },
        { label: '뷰티, 편의점', highlight: '5% 할인' },
        { label: 'KB Pay', highlight: '2%추가 할인' },
      ],
      monthlyUsageNote: '※전월 이용실적 30만원 이상',
      href: KB_CARD_LINKS.nori2,
    },
    {
      name: '트래블러스 체크카드(토심이)',
      subtitle: '여행이 일상인 프로여행러라면',
      images: [
        {
          src: getStaticCdnUrl('kb-card-event/card-2.png'),
          alt: '트래블러스 체크카드',
        },
      ],
      tags: ['#국내외겸용(Master)', '#연회비 없음'],
      benefits: [
        { label: '해외 이용 수수료', highlight: '1.25% 면제' },
        { label: '철도', highlight: '5,000원 할인' },
        { label: '전국맛집', highlight: '5,000원 할인' },
      ],
      monthlyUsageNote: '※전월 이용실적 20만원 이상',
      href: KB_CARD_LINKS.travelers,
    },
    {
      name: 'Youth Club 체크카드',
      subtitle: '빛나는 혜택, 청춘의 특권',
      images: [
        {
          src: getStaticCdnUrl('kb-card-event/card-3.png'),
          alt: 'Youth Club 체크카드 1',
        },
        {
          src: getStaticCdnUrl('kb-card-event/card-4.png'),
          alt: 'Youth Club 체크카드 2',
        },
      ],
      tags: ['#국내전용', '#국내외겸용(Master)', '#연회비 없음'],
      benefits: [
        {
          label: '[A팩] 6개 영역(OTT, APP등)',
          highlight: '최대 50% 할인',
        },
        {
          label: '[B팩] 6개 영역(쇼핑멤버십, 통신 등)',
          highlight: '최대 50% 할인',
        },
        { label: 'Mastercard', highlight: '플래티늄 기본서비스 제공' },
      ],
      monthlyUsageNote: '※전월 이용실적 20만원 이상',
      href: KB_CARD_LINKS.youthClub,
    },
  ],

  /** 05 혜택 제공 일정 */
  benefit: {
    deadline: currentDates.deadline,
    description: currentDates.benefitDescription,
  },

  /** 06 유의사항 */
  notices: {
    youthClubPromoLink: 'https://m.kbcard.com/z/e1000416',
    baroDiscountLink: 'https://ad-kbcard.com/checkcard_baro/2607/mo',
    complianceText: currentDates.complianceText,
  },
} as const;
